const rootUrl = `${window.location.protocol}//${window.location.host}`;

export { rootUrl };
